import { useState, useRef, useEffect } from 'react';
import './CustomDropdown.css';
import { useNavigate } from 'react-router-dom';

export default function CustomDropdown({isCollapsed, options, triggerLabel = "" }) {
  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const dropdownRef = useRef(null);
  const triggerRef = useRef(null);
  const navigate = useNavigate();

  const toggleDropdown = () => setOpen((prev) => !prev);

  const handleOptionClick = (option) => {
    setOpen(false);
    if (option.onClick) option.onClick();
    else if (option.url) navigate(option.url);
  };

  useEffect(() => {
    if (open && triggerRef.current && dropdownRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      const dropdownHeight = dropdownRef.current.offsetHeight;
      const dropdownWidth = dropdownRef.current.offsetWidth;
      const top = rect.top + rect.height + 8; // Just below the trigger
      const left = rect.left + rect.width / 2 - dropdownWidth / 2 + isCollapsed? 20: dropdownWidth / 2;

      setPosition({ top, left });
    }
  }, [open]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target) &&
        triggerRef.current &&
        !triggerRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  return (
    <div className="feed-custom-dropdown">
      <div ref={triggerRef} className="feed-dropdown-trigger" onClick={toggleDropdown}>
        {triggerLabel || "More Items"}
      </div>

      {open && (
        <div
          ref={dropdownRef}
          className="feed-dropdown-panel animate-from-bottom"
          style={{ position: 'absolute', top: position.top, left: position.left, cursor: 'pointer' }}
        >
          {options.map((option) => (
            <div
              key={option.label}
              className="feed-dropdown-option"
              onClick={() => handleOptionClick(option)}
            >
              <i className={option.icon} style={{ marginRight: 8 }}></i>
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
